// Libraries
import React from 'react'
import I18n from 'i18next'
import moment from 'moment'
import { isNil } from 'lodash'
import { Tooltip } from 'antd'

// Helpers
import {
  dateSort,
  filterPeriod,
  alphaSort
} from 'Components/TableLayout/Helpers'

const specs = {
  // Nom des éléments affichés et listés
  element: {
    name: 'preventionPlan',
    kind: 'male'
  },

  // Liste des boutons du tableau
  actions: {
    // Actions sur l'ensemble du tableau
    global: {
      create: {
        label: 'common.create',
        icon: 'plus'
      }
    },
    // Actions groupées sur les lignes du tableau
    selection: {
      delete: {
        buttonType: 'danger'
      }
    }
  },

  // Gestion de l'internationalisation
  locale: {
    emptyText: 'pages.preventionPlans.table.empty'
  },

  // Affichage du titre
  titleEnabled: true,

  // Affichage de la zone de recherche
  searchEnabled: true,

  // Render custom des en-têtes
  renderHeaderLeft: null,
  renderHeaderRight: null,

  // Gestion de la pagination
  pagination: {
    position: 'both',
    showSizeChanger: true,
    current: 1,
    pageSize: 10,
    pageSizeOptions: ['10', '25', '50', '100']
  },

  // Identifiant unique de chaque ligne du tableau
  rowKey: 'id',

  // Autorise les lignes en drag and drop
  areRowsDraggable: true,

  // Colonnes du tableau
  columns: {
    pdpnum: {
      width: 220,
      title: 'pages.preventionPlans.fields.pdpnum.title',
      dataIndex: 'pdpnum',
      key: 'pdpnum',
      render: pdpnum =>
        !isNil(pdpnum) ? pdpnum : I18n.t('common.unknown.male'),
      sorter: (...params) => alphaSort(params, 'pdpnum')
    },
     typePdp: {
      title: 'pages.preventionPlans.fields.typePdp.title',
      dataIndex: 'typePdp',
      key: 'typePdp',
      formField: {
        type: 'select',
        label: 'pages.preventionPlans.fields.typePdp.title',
        required: 'pages.preventionPlans.fields.typePdp.requiredMessage',
        placeholder: 'pages.preventionPlans.fields.typePdp.placeholder',
        options: [
          {
            id: 'ANNUEL',
            value: 'ANNUEL',
            label: 'pages.preventionPlans.fields.typePdp.options.annual'
          },
          {
            id: 'SPECIFIQUE',
            value: 'SPECIFIQUE',
            label: 'pages.preventionPlans.fields.typePdp.options.specific'
          },
          {
            id: 'AVENANT',
            value: 'AVENANT',
            label: 'pages.preventionPlans.fields.typePdp.options.avenant'
          }
        ]
      },
      empty: 'common.unknown.male'
    },
    isValid: {
      width: 80,
      title: 'pages.preventionPlans.fields.isValid.title',
      dataIndex: 'isValid',
      key: 'isValid',
      render: isValid =>
        isValid
          ? I18n.t('pages.preventionPlans.fields.isValid.valid')
          : I18n.t('pages.preventionPlans.fields.isValid.invalid'),
      sorter: (a, b) => (a.isValid === b.isValid ? 0 : a.isValid ? -1 : 1)
    },
    // todo ajout du type dans la colonne
    name: {
      width: 300,
      title: 'pages.preventionPlans.fields.name.title',
      dataIndex: 'name',
      key: 'name',
      render: name => (!isNil(name) ? name : I18n.t('common.unknown.male')),
      sorter: (...params) => alphaSort(params, 'name')
    },
    companies: {
      width: 250,
      title: 'pages.preventionPlans.fields.companies.title',
      dataIndex: 'companies',
      key: 'companies',
      render: companies => {
        if (!isNil(companies) && companies.length > 0) {
          return companies.map(company => (
            <span
              key={company.id}
              style={{
                display: 'inline-block',
                backgroundColor: '#f0f0f0',
                padding: '2px 8px',
                marginRight: '4px',
                marginTop: '4px',
                borderRadius: '6px'
                // fontSize: '12px'
              }}
            >
              {company.name}
            </span>
          ))
        }
        return ''
      }
      // render: companies =>
      //   !isNil(companies) && companies.length > 0
      //     ? companies.map(company => company.name).join(', ')
      //     : I18n.t('common.unknown.female')
      // sorter: (...params) => alphaSort(params, 'companies')
    },
    startDate: {
      width: 180,
      title: 'pages.preventionPlans.fields.startDate.title',
      dataIndex: 'startDate',
      key: 'startDate',
      render: startDate =>
        !isNil(startDate) ? (
          <Tooltip title={moment(startDate).format('L')}>
            {moment(startDate).calendar()}
          </Tooltip>
        ) : (
          I18n.t('common.unknown.female')
        ),
      sorter: (...params) => dateSort(params, 'startDate'),
      ...filterPeriod(null, moment(), 'startDate')
    },
    endDate: {
      width: 180,
      title: 'pages.preventionPlans.fields.endDate.title',
      dataIndex: 'endDate',
      key: 'endDate',
      render: endDate =>
        !isNil(endDate) ? (
          <Tooltip title={moment(endDate).format('L')}>
            {moment(endDate).calendar()}
          </Tooltip>
        ) : (
          I18n.t('common.unknown.female')
        ),
      sorter: (...params) => dateSort(params, 'endDate'),
      ...filterPeriod(null, moment(), 'startDate')
    }
  }
}

export default specs
